"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var convertListToArray_1 = __importDefault(require("../___utils/convertListToArray"));
var filterList_1 = __importDefault(require("../___utils/filterList"));
var groupList_1 = __importDefault(require("../___utils/groupList"));
var isType_1 = require("../___utils/isType");
var limitList_1 = __importDefault(require("../___utils/limitList"));
var reverseList_1 = __importDefault(require("../___utils/reverseList"));
var searchList_1 = __importDefault(require("../___utils/searchList"));
var sortList_1 = __importDefault(require("../___utils/sortList"));
var flatListProps_1 = require("../flatListProps");
var uiFunctions_1 = require("./uiFunctions");
var withList = function (List) {
    function DataList(props) {
        var list = props.list, limit = props.limit, reversed = props.reversed, renderWhenEmpty = props.renderWhenEmpty, // render/list related props
        filterBy = props.filterBy, // filter props
        group = props.group, groupBy = props.groupBy, groupOf = props.groupOf, showGroupSeparatorAtTheBottom = props.showGroupSeparatorAtTheBottom, groupReversed = props.groupReversed, groupSeparatorAtTheBottom = props.groupSeparatorAtTheBottom, groupSortedCaseInsensitive = props.groupSortedCaseInsensitive, groupSortedDescending = props.groupSortedDescending, groupSorted = props.groupSorted, groupSortedBy = props.groupSortedBy, // group props
        sortBy = props.sortBy, sortDesc = props.sortDesc, sort = props.sort, sortCaseInsensitive = props.sortCaseInsensitive, sortGroupBy = props.sortGroupBy, sortGroupDesc = props.sortGroupDesc, sortGroupCaseInsensitive = props.sortGroupCaseInsensitive, sortDescending = props.sortDescending, // sort props
        search = props.search, searchBy = props.searchBy, searchOnEveryWord = props.searchOnEveryWord, searchTerm = props.searchTerm, searchCaseInsensitive = props.searchCaseInsensitive, searchableMinCharactersCount = props.searchableMinCharactersCount, searchMinCharactersCount = props.searchMinCharactersCount;
        var renderList = (0, convertListToArray_1.default)(list);
        if (renderList.length === 0) {
            return (0, uiFunctions_1.renderBlank)(renderWhenEmpty);
        }
        if (reversed) {
            renderList = (0, reverseList_1.default)(renderList);
        }
        if (!(0, isType_1.isNil)(limit)) {
            var _a = "".concat(limit).split(","), from = _a[0], to = _a[1];
            renderList = (0, limitList_1.default)(renderList, from, to);
        }
        if (filterBy) {
            renderList = (0, filterList_1.default)(renderList, filterBy);
        }
        if (searchTerm || (search && search.term)) {
            var searchOptions = __assign(__assign({}, flatListProps_1.defaultProps.search), search);
            renderList = (0, searchList_1.default)(renderList, {
                by: searchOptions.by || searchBy || "0",
                caseInsensitive: searchOptions.caseInsensitive || searchCaseInsensitive,
                everyWord: searchOptions.onEveryWord ||
                    searchOptions.everyWord || // deprecated
                    searchOnEveryWord,
                term: searchOptions.term || searchTerm,
                minCharactersCount: searchOptions.searchableMinCharactersCount || // deprecated
                    searchOptions.minCharactersCount ||
                    searchMinCharactersCount ||
                    searchableMinCharactersCount || // deprecated
                    3,
            });
        }
        var sortOptions = __assign(__assign({}, flatListProps_1.defaultProps.sort), sort);
        if (sortOptions.by || sortBy || ((0, isType_1.isBoolean)(sort) && sort)) {
            renderList = (0, sortList_1.default)(renderList, {
                caseInsensitive: sortOptions.caseInsensitive || sortCaseInsensitive,
                descending: sortOptions.descending || sortDescending || sortDesc,
                by: sortOptions.by || sortBy,
            });
        }
        var groupOptions = __assign(__assign({}, flatListProps_1.defaultProps.group), group);
        if (groupOptions.by ||
            groupBy ||
            groupOf ||
            groupOptions.of ||
            groupOptions.limit) {
            var groupingOptions = {
                by: groupOptions.by || groupBy,
                limit: groupOptions.of || groupOf || groupOptions.limit,
                reversed: groupOptions.reversed || groupReversed,
            };
            var gList_1 = (0, groupList_1.default)(renderList, groupingOptions);
            renderList = gList_1.groupLists.reduce(function (newGList, aGroup, idx) {
                if (groupSorted ||
                    groupOptions.sorted ||
                    groupSortedBy ||
                    groupOptions.sortedBy ||
                    groupOptions.sortBy ||
                    sortGroupBy ||
                    sortOptions.groupBy // deprecated
                ) {
                    aGroup = (0, sortList_1.default)(aGroup, {
                        caseInsensitive: groupSortedCaseInsensitive ||
                            groupOptions.sortedCaseInsensitive ||
                            groupOptions.sortCaseInsensitive || // deprecated
                            sortGroupCaseInsensitive || // deprecated
                            sortOptions.groupCaseInsensitive,
                        descending: groupSortedDescending ||
                            groupOptions.sortedDescending ||
                            groupOptions.sortDescending || // deprecated
                            sortGroupDesc,
                        by: groupSortedBy ||
                            groupOptions.sortedBy ||
                            groupOptions.sortBy || // deprecated
                            sortGroupBy, // deprecated
                    });
                }
                var separator = [
                    "___list-separator",
                    gList_1.groupLabels[idx],
                    aGroup,
                ];
                if (groupOptions.separatorAtTheBottom ||
                    groupSeparatorAtTheBottom ||
                    showGroupSeparatorAtTheBottom) {
                    return __spreadArray(__spreadArray(__spreadArray([], newGList, true), aGroup, true), [separator], false);
                }
                return __spreadArray(__spreadArray(__spreadArray([], newGList, true), [separator], false), aGroup, true);
            }, []);
        }
        return react_1.default.createElement(List, __assign({}, props, { list: renderList }));
    }
    return (0, react_1.memo)((0, react_1.forwardRef)(function (props, ref) { return (react_1.default.createElement(DataList, __assign({}, props, { __forwarededRef: ref }))); }));
};
exports.default = withList;
//# sourceMappingURL=withList.js.map